import React from 'react'

import PropTypes from 'prop-types'

import './ambassadorsbtn-l.css'

const AmbassadorsbtnL = (props) => {
  return (
    <div className={`ambassadorsbtn-l-thq-images-elm ${props.rootClassName} `}>
      <div className="ambassadorsbtn-l-container1">
        <img
          alt={props.imageAlt2}
          src={props.imageSrc1}
          className="ambassadorsbtn-l-image1"
        />
        <svg viewBox="0 0 1024 1024" className="ambassadorsbtn-l-icon1">
          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
        </svg>
      </div>
      <div className="ambassadorsbtn-l-container2">
        <img
          alt={props.imageAlt11}
          src={props.imageSrc11}
          className="ambassadorsbtn-l-image2"
        />
        <svg viewBox="0 0 1024 1024" className="ambassadorsbtn-l-icon3">
          <path d="M316 366l196 196 196-196 60 60-256 256-256-256z"></path>
        </svg>
      </div>
    </div>
  )
}

AmbassadorsbtnL.defaultProps = {
  imageSrc11: '/nav patterns/consultancy.svg',
  imageAlt2: 'image',
  imageSrc1: '/nav patterns/consultancy.svg',
  rootClassName: '',
  imageAlt11: 'image',
}

AmbassadorsbtnL.propTypes = {
  imageSrc11: PropTypes.string,
  imageAlt2: PropTypes.string,
  imageSrc1: PropTypes.string,
  rootClassName: PropTypes.string,
  imageAlt11: PropTypes.string,
}

export default AmbassadorsbtnL
